import React from 'react'
import RequisiteAuditChangesCell from './RequisiteAuditChangesCell'
import { IRequisiteAuditItem } from '../core/response.types'
import { ROLE_LABEL } from '../core/consts'

const fmtDate = (iso: string) =>
  new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow',
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  }).format(new Date(iso))

interface Props { item: IRequisiteAuditItem }

const RequisiteAuditRow: React.FC<Props> = ({ item }) => {
  const rowStyle: React.CSSProperties = item.isCritical
    ? { borderLeft: '4px solid var(--bs-danger)' }
    : {}
  const rowClass = item.isCritical ? 'bg-light-danger' : ''

  const blame = item.blame
  const blameNode = blame.isSystem
    ? <em>Система</em>
    : (
      <div>
        <div className='font-monospace small'>{blame.uuid ?? blame.id ?? '—'}</div>
        {blame.role && <div className='text-muted small'>{ROLE_LABEL[blame.role] ?? blame.role}</div>}
      </div>
    )

  return (
    <tr className={rowClass} style={rowStyle}>
      <td>{fmtDate(item.createdAt)}</td>
      <td>{blameNode}</td>
      <td><RequisiteAuditChangesCell item={item} /></td>
    </tr>
  )
}

export default RequisiteAuditRow
